<template>
    <el-dialog class="el-dialogs" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 label-width="110px">
            <div class="dialogPadding">
                <div class="flex_l_t flexWarp">
                    <el-form-item v-if="title != '资源借阅'" label="借阅单号" prop="oddNumbersId">
                        <el-select style="width: 100%" v-model="searchForm.oddNumbersId"
                                   clearable @change="queryInfo"
                                   placeholder="请选择借阅单号">
                            <el-option
                                    v-for="item in applicationOddList"
                                    :key="item.id"
                                    :label="item.applicationOdd"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="借阅人" prop="createByName">
                        <div>{{ searchForm.createByName }}</div>
                    </el-form-item>
                    <el-form-item label="借阅目的" prop="purpose">
                        <el-select v-if="title == '资源借阅'" style="width: 100%" v-model="searchForm.purpose"
                                   clearable
                                   placeholder="请选择借阅目的">
                            <el-option
                                    v-for="item in $dictUtils.getDictList('purpose_type')"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <div v-else>{{ $dictUtils.getDictLabel("purpose_type", searchForm.purpose, '') }}</div>
                    </el-form-item>
                    <el-form-item label="借阅内容" prop="applicationContent">
                        <el-checkbox-group v-model="searchForm.applicationContent" :disabled="title != '资源借阅'">
                            <el-checkbox :label="'0'">脱敏字段</el-checkbox>
                            <el-checkbox :label="'1'">在线预览</el-checkbox>
                            <el-checkbox :label="'2'">文件下载</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="借阅开始时间" prop="applicationDate">
                        <el-date-picker v-if="title == '资源借阅'" v-model="searchForm.applicationDate"
                                        type="date" value-format="yyyy-MM-dd"
                                        style="width: 100%;" clearable
                                        :picker-options="pickerOptions"
                                        placeholder="选择日期">
                        </el-date-picker>
                        <div v-else>{{ searchForm.applicationDate }}</div>
                    </el-form-item>
                    <el-form-item label="借阅天数(天)" prop="applicationDay">
                        <el-input v-if="title == '资源借阅'" v-model.trim="searchForm.applicationDay"
                                  :placeholder="`请输入借阅天数(1~${this.borrowLength})`"
                                  @input="setBorrowDays('applicationDay')"
                                  clearable></el-input>
                        <div v-else>{{ searchForm.applicationDay }}</div>
                    </el-form-item>
                </div>
            </div>
            <el-form-item label="备注说明" prop="remark" style="padding-right: 40%;">
                <el-input v-if="title == '资源借阅'"
                          type="textarea"
                          :rows="4" resize="none"
                          maxlength="200"
                          placeholder="请输入内容(限200字)"
                          v-model="searchForm.remark">
                </el-input>
                <div v-else>{{ searchForm.remark }}</div>
            </el-form-item>
            <el-form-item label="借阅资源"></el-form-item>
            <div class="borrowing">
                <el-tabs v-model="seleMetadata" type="card" @tab-click="handleClick">
                    <el-tab-pane v-for="item in basicData" :label="item.basicDataName" :name="item.basicDataId"
                                 :key="item.basicDataId"></el-tab-pane>
                </el-tabs>
                <el-table
                        :data="dataList"
                        v-loading="loading"
                        size="small" height="250px"
                        class="table" ref="multipleTable" border>
                    <el-table-column prop="mingcheng" label="名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.jsonData.mingcheng }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="zhuangtai" label="状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.jsonData.zhuangtai }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="jiandingjieguo" label="鉴定结果" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.jsonData.jiandingjieguo }}</span>
                        </template>
                    </el-table-column>
                    </el-table-column>
                    <el-table-column prop="chuangjianren" label="创建人" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.jsonData.chuangjianren }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="chuangjianshijian" label="创建时间" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.jsonData.chuangjianshijian }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="xiugairen" label="最新修改人" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.jsonData.xiugairen }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="xiugaishijian" label="最新修改时间" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.jsonData.xiugaishijian }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="view(scope.row,)">查看</el-button>
                            <el-button type="text" v-show="!scope.row.map" size="small"
                                       @click="cancelBorrow(scope.row,scope.$index)">取消借阅
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="submit(0)" v-noMoreClick>保存</el-button>
            <el-button size="small" type="primary" @click="submit(1)" v-noMoreClick>提交</el-button>
        </div>
        <ResourceAddEditForm ref="resourceAddEditForm"></ResourceAddEditForm>
    </el-dialog>
</template>

<script>

import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";

export default {
    name: "addBorrowing",
    components: {ResourceAddEditForm},
    data() {
        return {
            title: '修改资源借阅单',
            butBame: '',
            typeName: '',
            visible: false,
            searchForm: {
                id: '',
                oddNumbersId: '',
                createByName: '',
                purpose: '',
                applicationContent: [],
                applicationDate: '',
                applicationDay: '',
                remark: '',
            },
            rules: {
                oddNumbersId: [
                    {required: true, message: '请选择借阅单号', trigger: 'change'}
                ],
                purpose: [
                    {required: true, message: '请选择借阅目的', trigger: 'blur'}
                ],
                applicationContent: [
                    {type: 'array', required: true, message: '请选择借阅内容', trigger: 'change'}
                ],
                applicationDate: [
                    {required: true, message: '请选择借阅开始时间', trigger: 'change'}
                ],
                applicationDay: [
                    {required: true, message: '请填写借阅天数', trigger: 'blur'}
                ],
            },
            applicationOddList: [],

            basicData: [],
            basicDataAccept:[],
            seleMetadata: '',
            dataList: [],
            loading: false,
            selectList: [],
            borrowLength: '',

            pickerOptions: {
                disabledDate(time) {
                    // 选择今天以及今天之后的日期
                    return time.getTime() < Date.now() - 8.64e7// 如果没有后面的-8.64e7就是不可以选择
                    // 选择今天以及今天之前的日期
                    // return time.getTime() > Date.now() - 8.64e7// 如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
        }
    },

    methods: {
        //butBame bill 加入借阅单
        init(selectList, butBame) {
            this.visible = true
            this.butBame = butBame
            this.basicData = []
            this.basicDataAccept = []
            this.dataList = []
            this.searchForm.id = ''
            if (this.butBame == 'bill') {
                this.title = '加入借阅单'
            } else {
                this.title = '资源借阅'
                this.searchForm.createByName = JSON.parse(sessionStorage.getItem('userInfo')).name
            }
            this.selectList = selectList
            this.getOhterData()
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
            })
        },

        handleClick(tab, event) {
            if (this.butBame == 'bill') {
                this.getDataList()
            } else {
                this.dataList = this.selectList.filter(item => {
                    return item.basicDataId == this.seleMetadata
                })
            }
        },

        getOhterData() {
            if (this.butBame == 'bill') {
                this.$axios(this.api.academic.getApplicationOddList, {}, 'get').then(data => {
                    this.applicationOddList = data.data
                })
            }
            let basicDataIds = this.selectList.map(item => {
                return item.basicDataId
            })
            this.$axios(this.api.metadata.getMetadataBasicDataNamesById, basicDataIds, 'post').then(data => {
                this.basicDataAccept = data
                this.basicDataAccept.forEach(item => {
                    this.$set(item, 'basicDataId', item.id)
                })
                if (this.butBame != 'bill'){
                    this.basicData = this.basicDataAccept
                    this.seleMetadata = this.basicData[0].basicDataId
                    this.handleClick()
                }
                this.loading = false
            })
            this.$axios(this.api.user.configKey + 'academic_resource_application', {}, 'get').then(data => {
                if (data && data.status) {
                    this.borrowLength = data.data
                }
            })
        },

        //单号查询信息
        queryInfo() {
            this.$axios(this.api.academic.resourceapplicationGetById + this.searchForm.oddNumbersId).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        if (key != 'oddNumbersId') {
                            if (key == 'applicationContent') {
                                this.searchForm[key] = data.data[key].split(',')
                            } else {
                                this.searchForm[key] = data.data[key]
                            }
                        }
                    })
                }
            })
            this.$axios(this.api.academic.resourceapplicationGetBasicDataList, {
                applicationId: this.searchForm.oddNumbersId,
            }).then(data => {
                if (data && data.status) {
                    this.basicData = data.data
                    if (this.basicDataAccept.length){
                        this.basicData.push(...this.basicDataAccept)
                        this.basicData = this.basicData.reduce((item, current) => {
                            const idExists = item.some(item => item.basicDataId === current.basicDataId);
                            if (!idExists) {
                                item.push(current);
                            }
                            return item;
                        }, []);
                    }
                    this.seleMetadata = this.basicData[0].basicDataId
                    this.getDataList()
                }
            })
        },

        getDataList() {
            this.loading = true
            this.$axios(this.api.academic.getResourceList, {
                applicationId: this.searchForm.oddNumbersId,
                basicDataId: this.seleMetadata,
            }, 'get').then(data => {
                if (data && data.status) {
                    this.dataList = data.data
                    this.dataList.forEach(item => {
                        this.$set(item, 'jsonData', item.map.jsonData)
                    })
                    let addData = this.selectList.filter(item => item.basicDataId == this.seleMetadata)
                    this.dataList.push(...addData)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        //查看
        view(row) {
            if (row.map) {
                this.$refs.resourceAddEditForm.init('view', row.map.id, '', row.map.basicDataId)
            } else {
                this.$refs.resourceAddEditForm.init('view', row.id, '', row.basicDataId)
            }
        },

        //取消借阅
        cancelBorrow(row, index) {
            this.$confirm(`您是否确认取消借阅该资源?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.dataList.splice(index, 1)
                this.selectList = this.selectList.filter(item => item.id != row.id)
            })
        },

        //通过驳回结束
        toexamineRefresh() {
            this.$emit('refresh')
            this.visible = false
        },

        //type 0保存 1提交
        submit(type) {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.butBame == 'bill') {
                        let resourceApplicationData = this.selectList.map(item => {
                            return {
                                resourceId: item.id,
                                basicDataId: item.basicDataId,
                            }
                        })
                        this.$axios(this.api.academic.resourceapplicationAppend, {
                            id: this.searchForm.id,
                            resourceApplicationData,
                        }, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success(`${type == 0 ? '保存' : '提交'}成功`)
                                this.$emit('refresh')
                                this.visible = false
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        let resourceApplicationData = this.dataList.map(item => {
                            return {
                                resourceId: item.id,
                                basicDataId: item.basicDataId,
                            }
                        })
                        this.searchForm.applicationContent = this.searchForm.applicationContent.join(',')
                        this.searchForm.applicationState = type
                        this.$axios(this.api.academic.resourceapplicationSave, {
                            ...this.searchForm,
                            resourceApplicationData,
                        }, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success(`${type == 0 ? '保存' : '提交'}成功`)
                                this.$emit('refresh')
                                this.visible = false
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },

        //只能输入大于0的正整数
        setBorrowDays(formName) {
            this.searchForm[formName] = this.searchForm[formName].replace(/[^0-9]/g, "")
            if (this.searchForm[formName] == 0) {
                this.searchForm[formName] = ''
            }
            if (this.searchForm[formName] * 1 > this.borrowLength * 1) {
                this.searchForm[formName] = this.borrowLength
            }
        },

    },
}
</script>

<style lang="scss" scoped>
.dialogPadding {
  padding-right: 40%;

  .el-form-item {
    width: 48%;
    margin-left: 2%;
  }

  .flexWarp {
    flex-wrap: wrap;
  }
}

.borrowing {
  padding: 0 35px 0;
  margin-top: -10px;
}

</style>
